var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { genericControllersRpc } from 'src/api/rpc';
import { error, success } from 'src/utils/notification/NotificationService';
/**
 * Queues an email operation through RPC
 * @param request The email request with routing information
 * @throws Error if the RPC call fails or returns an unknown result
 */
export function queue_email_operation(request) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        // Construct RPC payload
        const payload = {
            api_version: 1,
            action: 'call',
            entity: 'integrations.queue_email_operation',
            action_arguments: [
                {
                    argument_number: 1,
                    value: JSON.stringify(request),
                    type: 'jsonb',
                },
            ],
        };
        // Make RPC call
        const response = yield genericControllersRpc(payload);
        // Handle response
        if (response.result === 'error') {
            const messageString = ((_a = response.messages) === null || _a === void 0 ? void 0 : _a.join(', ')) || 'Unknown error';
            error(messageString);
            throw new Error(`Failed to queue email: ${messageString}`);
        }
        if (response.result === 'success') {
            success('Email queued successfully');
            return;
        }
        // Handle unexpected response
        throw new Error(`Unexpected response result: ${response.result}`);
    });
}
